export function getResultCountString(resultCount: number, resultCountRelation: string): string {
  if (resultCountRelation === 'gte') return `>${resultCount}`;
  return `${resultCount}`;
}
